// biome-ignore lint/style/noRestrictedImports: encapsulation
import { round as round_ } from "remeda";

import { unpurry } from "./_unpurry";

export const round = unpurry(round_, 2);
